module.exports = __webpack_public_path__ + "img/option-api-vs-composition-api-2.7db7368a.png";